module.exports = __webpack_public_path__ + "static/media/MT4.6860acce.mp3";